export const DEFAULT_AVAILABILITY_DOCK_HEIGHT_PX = 320;
export const MOBILE_AVAILABILITY_DOCK_HEIGHT_PX = 256;
export const MOBILE_AVAILABILITY_DOCK_BREAKPOINT_PX = 480;
export const MIN_AVAILABILITY_DOCK_HEIGHT_PX = 240;
export const MAX_AVAILABILITY_DOCK_VIEWPORT_OFFSET_PX = 96;

function getViewportWidth(): number {
  return typeof window === "undefined"
    ? MOBILE_AVAILABILITY_DOCK_BREAKPOINT_PX + 1
    : window.innerWidth;
}

function getViewportHeight(): number {
  return typeof window === "undefined"
    ? DEFAULT_AVAILABILITY_DOCK_HEIGHT_PX + MAX_AVAILABILITY_DOCK_VIEWPORT_OFFSET_PX
    : window.innerHeight;
}

export function getDefaultAvailabilityDockHeight(viewportWidth = getViewportWidth()): number {
  return viewportWidth <= MOBILE_AVAILABILITY_DOCK_BREAKPOINT_PX
    ? MOBILE_AVAILABILITY_DOCK_HEIGHT_PX
    : DEFAULT_AVAILABILITY_DOCK_HEIGHT_PX;
}

export function getMaxAvailabilityDockHeight(viewportHeight = getViewportHeight()): number {
  return Math.max(
    MIN_AVAILABILITY_DOCK_HEIGHT_PX,
    viewportHeight - MAX_AVAILABILITY_DOCK_VIEWPORT_OFFSET_PX,
  );
}

export function clampAvailabilityDockHeight(
  heightPx: number,
  viewportHeight = getViewportHeight(),
): number {
  return Math.min(
    getMaxAvailabilityDockHeight(viewportHeight),
    Math.max(MIN_AVAILABILITY_DOCK_HEIGHT_PX, heightPx),
  );
}
